import { IconModel } from "../IconModel";

/**
* CmsLinkModel defines model for cms links configuration
*
* @typedef CmsLinkModel
* @type {Object}
* @property {title} Title of the link
* @property {href} URL of the link
* @property {icon} Icon of the link
* @property {handler} Event handler which should navigate to the page/panel
*/

export class CmsLinkModel {
    title: string;
    icon: IconModel;
    href: string;
    handler: Function;

    constructor(cmsLinkData: CmsLinkModel) {
        this.title = cmsLinkData.title;
        this.icon = cmsLinkData.icon;
        this.href = cmsLinkData.href;
        this.handler = cmsLinkData.handler;
    }
}